import axiosInstance from './api';

export const fetchPublicIdeas = async () => {
  const response = await axiosInstance.get('/ideas/public');
  return response.data;
};

export const fetchIdeas = async (token) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  const response = await axiosInstance.get('/ideas', {
    headers,
  });
  return response.data;
};

export const createIdea = async (idea, token) => {
  const response = await axiosInstance.post('/ideas', idea, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const createAIIdea = async (description, token) => {
  try {
    const response = await axiosInstance.post(
      '/chat/create-idea',
      { prompt: description },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log('AI Idea creation response:', response.data);
    return response.data;
  } catch (err) {
    console.error('AI Idea creation error:', err.response?.data || err.message);
    throw new Error(err.response?.data?.detail || 'Failed to create AI idea');
  }
};

export const getIdea = async (ideaId, token) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  const response = await axiosInstance.get(`/ideas/${ideaId}`, {
    headers,
  });
  return response.data;
};

export const updateIdea = async (ideaId, idea, token) => {
  const response = await axiosInstance.put(`/ideas/${ideaId}`, idea, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const pinIdea = async (ideaId, isPinned, token) => {
  const response = await axiosInstance.patch(
    `/ideas/${ideaId}/pin`,
    { is_pinned: isPinned },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const deleteIdea = async (ideaId, token) => {
  const response = await axiosInstance.delete(`/ideas/${ideaId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const createInvite = async (token) => {
  try {
    const response = await axiosInstance.post('/invites', {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Create invite response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Create invite error:', err.response?.data || err.message);
    throw err;
  }
};

export const fetchInvites = async (token) => {
  try {
    const response = await axiosInstance.get('/invites', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Fetch invites response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Fetch invites error:', err.response?.data || err.message);
    throw err;
  }
};

export const fetchUsers = async (token) => {
  try {
    const response = await axiosInstance.get('/users', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Fetch users response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Fetch users error:', err.response?.data || err.message);
    throw err;
  }
};

export const fetchCurrentUser = async (token) => {
  try {
    const response = await axiosInstance.get('/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Fetch current user response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Fetch current user error:', err.response?.data || err.message);
    throw new Error(err.response?.data?.detail || 'Failed to fetch current user');
  }
};

export const updateUserProfile = async (profile, token) => {
  try {
    const response = await axiosInstance.patch('/me', profile, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Update profile response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Update profile error:', err.response?.data || err.message);
    throw err;
  }
};

export const generateResetPasswordLink = async (userId, token) => {
  try {
    const response = await axiosInstance.post(`/users/${userId}/reset-password`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Reset password link response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Reset password link error:', err.response?.data || err.message);
    throw err;
  }
};

export const toggleUserActive = async (userId, token) => {
  try {
    const response = await axiosInstance.patch(`/users/${userId}/toggle-active`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log('Toggle user active response:', response.data);
    return response.data;
  } catch (err) {
    console.error('Toggle user active error:', err.response?.data || err.message);
    throw err;
  }
};

export const signup = async (username, displayName, password, passwordConfirm, inviteToken) => {
  const response = await axiosInstance.post('/auth/signup', {
    username,
    display_name: displayName,
    password,
    password_confirm: passwordConfirm,
    invite_token: inviteToken,
  });
  return response.data;
};

export const resetPassword = async (resetToken, password, passwordConfirm) => {
  const response = await axiosInstance.post('/auth/reset-password', {
    reset_token: resetToken,
    password,
    password_confirm: passwordConfirm,
  });
  return response.data;
};

export const getIdeaComponents = async (ideaId, token) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  
  const response = await axiosInstance.get(`/components/idea/${ideaId}`, {
    headers,
  });
  return response.data;
};

export const createComponent = async (ideaId, componentData, token) => {
  try {
    const response = await axiosInstance.post(
      '/components',
      {
        ...componentData,
        idea_id: ideaId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error('API Error:', err.response?.data || err.message);
    throw new Error(err.response?.data?.detail || 'Failed to create component');
  }
};

export const updateComponent = async (componentId, componentData, token) => {
  try {
    const response = await axiosInstance.put(`/components/${componentId}`, componentData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    console.error('Update component error:', err.response?.data || err.message);
    throw new Error(err.response?.data?.detail || 'Failed to update component');
  }
};

export const deleteComponent = async (componentId, token) => {
  try {
    const response = await axiosInstance.delete(`/components/${componentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (err) {
    console.error('Delete component error:', err.response?.data || err.message);
    throw new Error(err.response?.data?.detail || 'Failed to delete component');
  }
};